import { render, staticRenderFns } from "./smallnav.vue?vue&type=template&id=168b3363&scoped=true"
import script from "./smallnav.vue?vue&type=script&lang=js"
export * from "./smallnav.vue?vue&type=script&lang=js"
import style0 from "./smallnav.vue?vue&type=style&index=0&id=168b3363&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168b3363",
  null
  
)

export default component.exports